// wrap the root element with provider to use context
import Provider from "./provider"
export const wrapRootElement = Provider